import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

function Sliders1_Hotels({ section }) {
  useEffect(() => {
    const updateClassBasedOnScreenSize = () => {
      const element = document.querySelector(".hotels-page-margin");
      if (!element) return;

      if (window.innerWidth >= 1024) {
        element.classList.add("mb-5");
      } else {
        element.classList.remove("mb-5");
      }
    };

    updateClassBasedOnScreenSize();
    window.addEventListener("resize", updateClassBasedOnScreenSize);

    return () => {
      window.removeEventListener("resize", updateClassBasedOnScreenSize);
    };
  }, []);

  const fallbackItems = [
    { title: 'Hyderabad', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/hyderabad.png', link_url: '/hotel-list' },
    { title: 'Mumbai', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/mumbai.png', link_url: '/hotel-list' },
    { title: 'Manali', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/manali.png', link_url: '/hotel-list' },
    { title: 'Ayodhya', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/ayodhya.png', link_url: '/hotel-list' },
    { title: 'Goa', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/goa.png', link_url: '/hotel-list' },
  ];
  const items = section?.Items?.length ? section.Items : fallbackItems;

  return (
    <div className="container swiper pb-5 hotels-popular-destinations">
      <div className="popular-state pb-0 pt-5 hotels-page-margin">
        <div className="container">
          <div className="title">
            <h3 className="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Popular </span>}{section?.title || 'Destinations'}</h3>
          </div>
        </div>
      </div>

      <Swiper
        className="slide-content"
        modules={[Navigation]}
        navigation={{
          nextEl: '.hotels-popular-next',
          prevEl: '.hotels-popular-prev',
        }}
        slidesPerView={5}
        spaceBetween={25}
        loop={true}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 15 },
          640: { slidesPerView: 3, spaceBetween: 18 },
          1024: { slidesPerView: 5, spaceBetween: 25 },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide className="card" key={`${item.title || item.name}-${index}`}>
            <div className="image-content">
              <div className="card-image" >
                <a href={item.link_url || '/hotel-list'} target="_blank" rel="noreferrer">
                  <img src={item.image_url} alt={item.title || item.name || ''} className="card-img" />
                </a>
              </div>
            </div>
            <div className="card-content">
              <a href={item.link_url || '/hotel-list'} target="_blank" rel="noreferrer">
                <h2 className="properties-title">
                  <span className="property-number">{item.subtitle?.split(' ')?.[0] || '1527'}</span> {item.subtitle?.replace(/^\S+\s*/, '') || 'Properties'} <i className="fa fa-arrow-right p-l-6"></i>
                </h2>
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="swiper-button-next swiper-navBtn hotels-popular-next"></div>
      <div className="swiper-button-prev swiper-navBtn hotels-popular-prev"></div>
    </div>
  );
}

export default Sliders1_Hotels;
